import React from 'react'
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
    UiButton,UiIconButton
} from "../../../../../_uiComponents/common/form/UiButton";
import UiTableHead from '../../../../_uiComponents/UiTableHead';
import TablePagination from '@mui/material/TablePagination';
import Stack from '@mui/material/Stack';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


export default function RewardDistributionSchedule(props) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(8);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState();


    const headings = [
        { id: 'distributionDate', name: 'Distribution Date' },
        { id: 'pointsAllocated', name: 'Points Allocated' },
        { id: 'status', name: 'Status' },
        { id: 'approvedBy', name: 'Approved By' },
        { id: 'approvedOn', name: 'Approved On' },
        { id: '', name: '' }
    ]
    const rows = [
        {
            id: 1,
            distributionDate: '2024-01-01',
            pointsAllocated: '2000',
            status: 'Distributed',
            approvedBy: 'William',
            approvedOn: '2024-01-01',
        },
        {
            id: 2,
            distributionDate: '2024-01-01',
            pointsAllocated: '2000',
            status: 'Scheduled',
            approvedBy: 'William',
            approvedOn: '2024-01-01',
        },
    ]
    //Sorting
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //Data sorting
    const sortingRows = React.useMemo(
        () =>
            stableSort(rows, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, rows],
    );


    return (
        <>
            <div className='sba-table-main-wr'>
                <TableContainer component={Paper} sx={{mt:1}}>
                    <Table sx={{ minWidth: 650, mt: 0 }} aria-label="simple table" className='sbt-data-grid'>
                        <UiTableHead
                            headings={headings}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort} />
                        <TableBody>
                            {sortingRows.map((row, index) => (
                                <>

                                    <TableRow>
                                        <TableCell>
                                            {row.distributionDate}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.pointsAllocated}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.status}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.approvedBy}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.approvedOn}
                                        </TableCell>
                                        <TableCell align="center">
                                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                                            <UiIconButton name="Summary" variant="contained" size="small" color="primary" icon={<FileDownloadIcon/>}/>
                                            <UiButton name="Approve" variant="contained" size="small" color="success"/>
                                        </Stack>
                                        </TableCell>
                                    </TableRow>
                                </>
                            ))}                       
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />



        </>
    )
}
